<div *ngIf="!containsError">
  <div *ngIf="successMess">
    <div class="successMessAlign">
      <p>
      <li>Loan Status Maintenance Transaction successfully submitted for Loan No. {{successLoanNumber}},
      effective date: {{successEffDate}} and Action Code: {{actionCodeType}}</li>
      <li *ngFor="let warningMsg of displayWarningMsg">{{warningMsg}}</li>
      </p>
    </div>
  </div>
  <div>
    <div class="errorMessage " *ngIf="errorMessage.length">
      {{errHeading}}
      <li *ngFor="let message of errorMessage">{{message}}</li>
      <hr class="hrStyle">
    </div>
  </div>
  <div class="notesMess">
    1. Type in the loan number. 2. Type in the effective date. 3. Select an action code. 4. Click on Submit to submit a transaction. 5. Click on Clear to clear all the fields. 6. Click on LoanDetail to get the details on the loan. 7. Click on Transactions to view all the transactions for the loan.
  </div>
  <div class="indicates">
    <span class="EMBRequiredControl">+</span><span class="EMBMessageCue"> Indicates
	            required information</span>
  </div>
  <br>
  <span class="adminTblAlign">
         <div class="ui-g-2 lblAlign">  <label class="EMBRequiredControl"> + &nbsp; </label>Loan Number:	 </div>
         <div class="ui-g-2"> <input type="text" maxlength="9" [(ngModel)]='loanNumber' maxlength="10"
                                     (keyup)="trackKeyPress($event)" autofocus fmTextInput></div>
      </span>
  <span class="adminTblAlign">
         <div class="ui-g-2 lblAlign">  <label class="EMBRequiredControl"> + &nbsp; </label>Effective Date: </div>
         <div class="ui-g-3">

         <fm-calendar id ="dteffectiveDateFrom" dateFormat="mm/dd/yy" placeholder="&nbsp;&nbsp;MM/DD/YYYY" [(ngModel)]='effDate'
                      [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')"
                      (keyup)="trackKeyPress($event)" [showClear]="true"></fm-calendar>

         </div>
  </span>
  <span class="adminTblAlign">
        <div class="ui-g-2 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label> Action Code:  </div>
        <div class="ui-g-2">   <fm-select
          [options]="actionCode"
          [(ngModel)]="actionCodeType"
          ariaLabelledBy="default"
        ></fm-select></div>
      </span>
  <div class="btnAlign">
    <button fmButton type="button" [small]="true" label="Clear" (click)="clearBtn()"
            class="dispbuttonMargin"></button>
    <button fmButton type="button" [small]="true" [primary]="true" label="Submit" (click)="loanStatusMaintneComponent()"
            class="dispbuttonMargin"></button>
    <button fmButton type="button" [small]="true" [primary]="true" label="Loan Detail" (click)="loanDetail()"
            class="dispbuttonMargin"></button>
    <button fmButton type="button" [small]="true" [primary]="true" label="Transactions"
            (click)="showloanDetailWrappers()"
            class="dispbuttonMargin"></button>
  </div>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
